// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608200559/js/" + chunkId + "." + {"44":"64b2dd65","225":"7cca7182","481":"019ea724","486":"d4e3a8c7","770":"46db833d"}[chunkId] + ".0.23561937285287948.chunk.js";
};